import React from 'react';
import { useSelector } from 'react-redux';
import { selectDarkMode } from '../../../app/store/slices/uiSlice';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import DOMPurify from 'dompurify';

export const RichTextEditor = ({ name, value, onChange, placeholder, disabled }) => {
  const darkMode = useSelector(selectDarkMode);

  const handleChange = (content) => {
    const sanitized = DOMPurify.sanitize(content, {
      ALLOWED_TAGS: ['p', 'br', 'strong', 'em', 'u', 's', 'h1', 'h2', 'h3', 'ol', 'ul', 'li', 'a'],
      ALLOWED_ATTR: ['href', 'target', 'rel']
    });
    onChange({ target: { name, value: sanitized } });
  };

  const modules = {
    toolbar: [
      [{ 'header': [1, 2, 3, false] }],
      ['bold', 'italic', 'underline', 'strike'],
      [{ 'list': 'ordered'}, { 'list': 'bullet' }],
      ['link'],
      ['clean']
    ]
  };

  return (
    <div className={`rich-text-editor ${darkMode ? 'dark-mode' : ''}`}>
      <ReactQuill
        theme="snow"
        value={value || ''}
        onChange={handleChange}
        placeholder={placeholder}
        readOnly={disabled}
        modules={modules}
        className={disabled ? 'opacity-50' : ''}
      />
    </div>
  );
};
